import { PageLayout, TopBar, useLocale } from 'shared-ui';

import { AppMessages } from 'i18n/messages';

import { PermissionsSummaryReportContainer } from './permissionsSummaryReport/PermissionsSummaryReportContainer';
import { IssuedCardsReportContainer } from './issuedCardsReport/IssuedCardsReportContainer';
import * as Styled from './Reports.styles';
import { EventsReportContainer } from './eventsReport/EventsReportContainer';
import { OwnersWithoutEventsReportContainer } from './ownersWithoutEventsReport/OwnersWithoutEventsReportContainer';
import { AttendanceTimeReportContainer } from './attendanceTimeReport';
import { InneEventsReportContainer } from './inneEventsReport/InneEventsReportContainer';
import { PresentOwnersReportContainer } from './presentOwnersReport';

export const Reports = () => {
  const { formatMessage } = useLocale();

  return (
    <PageLayout
      header={formatMessage({ id: AppMessages['reports.title'] })}
      renderContent={() => (
        <div>
          <TopBar gridTemplateColumns="1fr">
            <TopBar.EmptyBarWithLine />
          </TopBar>

          <Styled.ReportsContainer>
            <PermissionsSummaryReportContainer />

            <IssuedCardsReportContainer />

            <OwnersWithoutEventsReportContainer />

            <EventsReportContainer />

            <InneEventsReportContainer />

            <AttendanceTimeReportContainer />

            <PresentOwnersReportContainer />
          </Styled.ReportsContainer>
        </div>
      )}
    />
  );
};
